import Icon from 'veui/components/Icon'
import { IconBullseyeHit } from 'dls-icons-vue'

Icon.register('bullseye-hit', IconBullseyeHit)
